/* eslint-disable */
export default {
    methods: {
        __addPathValue(destination, path, value, startPath) {
            let model = destination;
            const attributes = (startPath ? path.substring(startPath.length + 1) : path).split(".");
            const [last] = attributes.splice(-1);

            attributes.forEach(attribute => {
                if (!model.hasOwnProperty(attribute)) {
                    model[attribute] = {};
                }
                model = model[attribute];
            });

            model[last] = value;
        },
        __getPathValue(dataModel, path, startPath) {
            const attributes = (startPath ? path.substring(startPath.length + 1) : path).split(".");
            const max = attributes.length;
            let searchModel = dataModel, loop = 0, found = true;

            while (loop < max && found) {
                if (searchModel.hasOwnProperty(attributes[loop])) {
                    searchModel = searchModel[attributes[loop]];
                } else {
                    found = false;
                    searchModel = null;
                }
                loop++;
            }

            return {
                found,
                data: searchModel
            };
        }
    }
};
